/* eslint-disable no-useless-catch */
import { ENV } from "../utils";

export class Level {
  baseApi = ENV.BASE_API;

  async getLevels(accessToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.LEVEL}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createLevel(accessToken, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.LEVEL}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateLevel(accessToken, levelId, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.LEVEL}/${levelId}`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteLevel(accessToken, levelId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.LEVEL}/${levelId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
